// Shared utility for constructing localized news provider keys
// Centralizing this avoids duplication across hooks and components.

/**
 * Build the i18n key for a news provider id.
 * @param {string|number} providerId
 * @returns {string} i18n key like `news.provider.<id>`
 */
export const newsProvider = (providerId) => `news.provider.${providerId}`;

export default newsProvider;
